import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { timezoneFn } from './timezone';

export const timezoneValidator =
	(
		forbiddenVals: string | Array<string>,
		timezoneSeparator = '%TZ'
	): ValidatorFn =>
	(control: AbstractControl): ValidationErrors | null => {
		const { value } = control;
		return timezoneFn(value, forbiddenVals, timezoneSeparator);
	};
